



































import Vue from 'vue'
import { UserProcedureDto } from '@/Application/Procedures'
import ProvinceName from '@/UI/Procedures/ProvinceName.vue'
export default Vue.extend({
  name: 'BidProcedureRow',
  components: { ProvinceName },
  props: {
    procedure: {
      type: UserProcedureDto,
      required: true
    }
  }
})
